export enum enumDefault {
  screen = '',
  modal = 'fadeInUpBig',
}
